import React from 'react';

import {
    SchoolsSmall,
    NationalrailstationColourSmall,
    LondondlrstationColourSmall,
    LondonundergroundstationColourSmall,
    LondonovergroundstationColourSmall,
    UkairportOutlineSmall,
    UkferryportSmall
} from '@blueprint/icons';

const iconMap = {
    uk_school_primary: <SchoolsSmall data-testid="schools" />,
    uk_school_secondary: <SchoolsSmall data-testid="schools" />,
    uk_school_primary_and_secondary: <SchoolsSmall data-testid="schools" />,
    uk_airport: <UkairportOutlineSmall data-testid="uk_airport" />,
    uk_ferry_port: <UkferryportSmall data-testid="uk_ferry_port" />,
    national_rail_station: (
        <NationalrailstationColourSmall data-testid="national_rail_station" />
    ),
    london_dlr_station: (
        <LondondlrstationColourSmall data-testid="london_dlr_station" />
    ),
    london_underground_station: (
        <LondonundergroundstationColourSmall data-testid="london_underground_station" />
    ),
    london_overground_station: (
        <LondonovergroundstationColourSmall data-testid="london_overground_station" />
    )
} as { [key: string]: JSX.Element };

type AmenityIconProps = {
    type?: string;
};

const AmenityIcon: React.FC<AmenityIconProps> = ({ type }) => {
    if (!type || !iconMap[type]) return null;
    return iconMap[type];
};

export default AmenityIcon;
